define.alias("ember-power-select/components/power-select-multiple/trigger", "calendar/components/power-select-multiple/trigger");